import React from "react";
import { motion } from "framer-motion";

/**
 * Marquee — slow, editorial horizontal ticker. Duplicates its children twice
 * for a seamless loop. Configurable speed (higher = slower) and direction.
 */
export default function Marquee({ items, speed = 60, className = "", separator = "✱" }) {
  const row = (
    <div className="flex shrink-0 items-center gap-10 pr-10">
      {items.map((t, i) => (
        <React.Fragment key={`${t}-${i}`}>
          <span className="whitespace-nowrap font-display text-[clamp(2rem,6vw,5rem)] leading-none">
            {t}
          </span>
          <span className="text-[clamp(1.2rem,3vw,2.4rem)] leading-none" style={{ color: "var(--mv-gold)" }}>
            {separator}
          </span>
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <div className={`overflow-hidden select-none ${className}`}>
      <motion.div
        className="flex"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: speed, ease: "linear", repeat: Infinity }}
      >
        {row}
        {row}
      </motion.div>
    </div>
  );
}
